<div class="has-menu-dropdown" [id]="id">
  <a (click)="clicked()">
    <i [className]="image"></i>
    @if (title) {
      {{ title | translate }}
    }
  </a>

  <ul class="as-dropdown as-dropdown--top" aria-label="submenu">
    @for (item of items; track item) {
      @if (item.children && item.children.length && !item.dynamic) {
        <asg-dropdown
          [image]="item.icon"
          [title]="item.isChild ? item.title : ''"
          [items]="item.children"
          [uiState]="uiState"
          [id]="id + item.feature"
          [parentId]="id">
        </asg-dropdown>
      } @else {
        <asg-desktop-menu-item [item]="item" [uiState]="uiState" (closeDropdown)="closeDropdown()"></asg-desktop-menu-item>
      }
    }
  </ul>
</div>
